import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke}    from "@Common/react/invoke";
import {keyed}     from "@Common/react/keyed";
import {UseState}  from "@Common/react/use-state";

export const PreloadImages = ({images, next}) => cs(
    ["loadeds", (_, next) => UseState({initValue: [], next})],
    ({loadeds}) => fragments(
        next({
            ready: images.findIndex((img) => loadeds.value.indexOf(img) === -1) === -1,
        }),

        images.map((url) => cs(
            keyed(url),
            () => Invoke({
                action: () => {
                    const img = new Image();
                    img.onload = () => {
                        // console.log("loaded url", url);
                        loadeds.change((_) => [..._, url]);
                    };
                    img.onerror = () => {
                        // console.log("error url", url);
                        loadeds.change((_) => [..._, url]);
                    };
                    img.src = url;
                },
            }),
        ))
    ),
);

//<link rel="preload" href="https://via.placeholder.com/160" as="image">